<template>
  <radio-selection
      v-bind="$attrs"
      :title="$options.SELECTION_TITLE"
      :options="$options.SELECTION_METHODS"
      :value="value"
      @change="$emit('input', $event)"/>
</template>

<script>
import RadioSelection from '../../components/RadioSelection';

const SELECTION_TITLE = 'How do you prefer to be contacted?';
const SELECTION_METHODS = [
  {
    text: 'Phone',
    value: 'PHONE',
    icon: 'phone',
    size: 48,
  },
  {
    text: 'Email',
    value: 'EMAIL',
    icon: 'email',
    size: 48,
  }];

export default {
  name: 'preferred-contact',
  SELECTION_TITLE,
  SELECTION_METHODS,
  components: {
    RadioSelection,
  },
  props: {
    value: {
      type: String,
      required: true,
    },
  },
};
</script>
